// extracted by mini-css-extract-plugin
export default {"arrow":"ArrowLine_arrow__foz2u"};